// extracted by mini-css-extract-plugin
module.exports = {"user-settings":"Settings_user-settings__3TA-W","user-settings__header":"Settings_user-settings__header__3Pyd_"};